import BoxLayout from "./BoxLayout";
import { motion } from "framer-motion";
import {coreFeatures,technicalExpertise} from './data'
import { TechnicalExpertise } from "./TechnicalExpertise";

export const GrayTextBoxLayout = () => {
  return (
    <section className="container space-y-32">
        <div className="space-y-10">
 
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
        className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] text-center    font-bold text-dark font-butler"
      >
        Core Features of Mobile Apps
      </motion.h2>
        <div className="flex flex-wrap  gap-x-6 gap-y-8 justify-center ">
        {coreFeatures.map((list,index) => (
          <BoxLayout key={index} heading={list.heading} Iconimg={list.img} text={list.text} color='bg-[#f3ebfa] '/>
      ))}
      </div>
        </div>
        
      <TechnicalExpertise/>
     </section> 
  );
};
